let baseUrl = process.env.REACT_APP_BASE_URL;

export { baseUrl };

